import { Component } from '@angular/core';
import { BaseComponent } from "../base/base.component";

import { AppContext } from "../../app.context";
import { AppInsightsService } from "../../services/app-insights.service";
import { ReferenceDataService } from "../../services/reference-data.service";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  providers: [
    AppInsightsService
  ]
})
export class AppComponent extends BaseComponent {

  constructor(
    readonly appContext: AppContext,
    readonly appInsightsService: AppInsightsService,
    readonly referenceDataService: ReferenceDataService) {
      super(appContext, appInsightsService);
  }
}
